var React = require('react');

function CloudEffect (props) {
    return React.createElement("svg",props,[React.createElement("path",{"opacity":"0.3","d":"M193.425 5.97209C276.844 43.5929 348.098 24.8543 357.543 69.7647C364.079 100.841 351.702 153.651 256.126 154.273C219.607 154.51 154.166 137.371 94.1933 144.459C51.6609 149.486 -10.487 124.831 1.50964 86.6696C18.7753 31.7472 141.559 -17.4188 193.425 5.97209Z","key":0}),React.createElement("defs",{"key":1},React.createElement("clipPath",{"id":"cloud-effect"},React.createElement("path",{"opacity":"1","d":"M193.425 5.97209C276.844 43.5929 348.098 24.8543 357.543 69.7647C364.079 100.841 351.702 153.651 256.126 154.273C219.607 154.51 154.166 137.371 94.1933 144.459C51.6609 149.486 -10.487 124.831 1.50964 86.6696C18.7753 31.7472 141.559 -17.4188 193.425 5.97209Z"})))]);
}

CloudEffect.defaultProps = {"width":"359","height":"155","viewBox":"0 0 359 155"};

module.exports = CloudEffect;

CloudEffect.default = CloudEffect;
